import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { message } from "antd";
import axiosHttp from "services/axiosHttp";

//create action
export const updateSopStatus = createAsyncThunk("updateSopStatus", async ({ id, data }) => {
	const token = localStorage.getItem("auth_token");
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
			"Access-Control-Allow-Origin": "*",
			"Content-Type": "application/json",
			Accept: "application/json",
		},
	};
	const response = await axiosHttp.patch(`sop/update/status?id=${id}`, data, config);

	return response.data;
});

const SopStatusUpdateSlice = createSlice({
	name: "SopStatusUpdateSlice",
	initialState: {
		isLoading: false,
		error: null,
	},

	extraReducers: (builder) => {
		builder.addCase(updateSopStatus.pending, (state, action) => {
			state.isLoading = true;
		});

		builder.addCase(updateSopStatus.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
		});
		builder.addCase(updateSopStatus.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export default SopStatusUpdateSlice.reducer;
